<template>
  <!-- メインコンテンツエリア -->
  <main class="l-main">
    <!-- ログインエリア -->
    <div class="l-main-content">
      <!-- ロゴ -->
      <login-logo />
      <!-- /ロゴ -->

      <!-- ログインフォーム -->
      <password-forget-message :login-url="loginUrl" />
      <!-- /ログインフォーム -->

      <!-- コピーライト -->
      <login-copyright />
      <!-- /コピーライト -->

    </div>
    <!-- /ログインエリア -->
  </main>
  <!-- /メインコンテンツエリア -->
</template>

<script>
export default {
  props: {
    loginUrl: String,
  },
}
</script>
